module.exports = __webpack_public_path__ + "static/img/film-80px.237e11d6.png";